.back {
  display: inline-block;
  margin-bottom: 16px;
  color: var(--muted);
  text-decoration: none;
  font-size: 14px;
}

.back:hover {
  color: var(--text);
}

.header {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;
}

.name {
  margin: 0 0 6px;
  overflow-wrap: anywhere;
}

.badges {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.grid {
  display: grid;
  grid-template-columns: minmax(280px, 360px) minmax(0, 1fr);
  gap: 16px;
  align-items: start;
}

.side {
  display: grid;
  gap: 16px;
}

.side > section {
  margin: 0;
}

.facts {
  display: grid;
  gap: 10px;
  margin: 0;
}

.fact {
  display: grid;
  grid-template-columns: 140px minmax(0, 1fr);
  gap: 8px;
  font-size: 14px;
}

.fact dt {
  font-size: 13px;
}

.fact dd {
  margin: 0;
  overflow-wrap: anywhere;
}

.blocked {
  margin: 0 0 12px;
  padding: 10px 12px;
  border-radius: var(--radius-field);
  background: color-mix(in srgb, var(--danger) 14%, transparent);
  color: var(--danger);
  font-size: 14px;
}

.field {
  display: grid;
  gap: 6px;
  margin-bottom: 12px;
}

.actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 4px;
}

.tabs {
  display: flex;
  gap: 4px;
  margin-bottom: 12px;
  padding: 4px;
  border-radius: 999px;
  background: var(--pill-bg);
  border: 1px solid var(--pill-line);
  overflow-x: auto;
}

.tab,
.tabActive {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border: 0;
  border-radius: 999px;
  background: transparent;
  color: var(--muted);
  font-size: 14px;
  white-space: nowrap;
}

.tabActive {
  background: var(--fill);
  background-image: var(--fill-gradient);
  color: var(--on-fill);
}

.count {
  font-size: 12px;
  opacity: 0.7;
}

.list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.item {
  padding: 10px 0;
  border-bottom: 1px solid var(--line);
  font-size: 14px;
}

.item:last-child {
  border-bottom: 0;
}

.note {
  margin-top: 4px;
  color: var(--text);
  font-style: italic;
}

@media (max-width: 860px) {
  .grid {
    grid-template-columns: 1fr;
  }
}

.sourceValue {
  display: grid;
  gap: 2px;
}

.sourceMeta {
  font-size: 12px;
}
